import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Users, Zap, Heart, Shield, TrendingUp } from 'lucide-react';
import { Breadcrumbs } from '../components/Breadcrumbs';
export function AboutPage() {
  return <div className="min-h-screen bg-slate-50" data-id="element-331">
      {/* Header */}
      <header className="sticky top-0 z-10 backdrop-blur supports-[backdrop-filter]:bg-white/70 bg-white/90 border-b border-slate-200" data-id="element-332">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-4" data-id="element-333">
          <div className="flex items-center justify-between" data-id="element-334">
            <div className="flex items-center gap-4" data-id="element-335">
              <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-id="element-336">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4yJ3FscyPfrN1xAm7crLNW/ChatGPT_Image_Dec_2%2C_2025%2C_10_42_07_PM.png" alt="Shopping Expert.ai Logo" className="h-12 object-contain" data-id="element-337" />
                <span className="text-xl font-bold text-slate-900" data-id="element-338">
                  AI Shopping Expert
                </span>
              </Link>
            </div>
            <nav className="hidden md:flex items-center gap-6 text-sm" data-id="element-339">
              <Link to="/" className="text-slate-600 hover:text-slate-900 font-medium" data-id="element-340">
                Home
              </Link>
              <Link to="/research" className="text-slate-600 hover:text-slate-900 font-medium" data-id="element-341">
                Research Tools
              </Link>
              <Link to="/about" className="text-slate-900 font-semibold border-b-2 border-slate-900 pb-1" data-id="element-342">
                About
              </Link>
              <Link to="/contact" className="text-slate-600 hover:text-slate-900 font-medium" data-id="element-343">
                Contact
              </Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="mx-auto max-w-4xl px-4 sm:px-6 py-12" data-id="element-344">
        <Breadcrumbs items={[{
        label: 'About',
        href: '/about'
      }]} data-id="element-345" />

        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8 sm:p-12" data-id="element-346">
          <h1 className="text-4xl font-bold text-slate-900 mb-6" data-id="element-347">
            About ShoppingExpert.ai
          </h1>

          {/* Mission Statement - Trustpilot Style */}
          <div className="mb-12 p-8 rounded-2xl bg-gradient-to-br from-blue-50 to-cyan-50 border-2 border-blue-200 text-center" data-id="element-348">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-349">
              Our Mission
            </h2>
            <p className="text-xl text-slate-700 leading-relaxed" data-id="element-350">
              Our mission is simple: help people make smarter decisions with AI
              — without the noise, hype, or guesswork.
            </p>
          </div>

          <div className="prose prose-slate max-w-none" data-id="element-351">
            <p className="text-lg text-slate-700 leading-relaxed mb-6" data-id="element-352">
              ShoppingExpert.ai is the independent directory of AI Shopping
              Agents & Sales Advisors. We help millions of shoppers make smarter
              purchasing decisions by connecting them with verified AI tools for
              every shopping need.
            </p>

            <div className="grid gap-6 sm:grid-cols-2 my-8" data-id="element-353">
              <div className="flex gap-4" data-id="element-354">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-purple-100 grid place-items-center" data-id="element-355">
                  <Target size={24} className="text-purple-600" data-id="element-356" />
                </div>
                <div data-id="element-357">
                  <h3 className="font-bold text-slate-900 mb-2" data-id="element-358">What We Do</h3>
                  <p className="text-sm text-slate-700" data-id="element-359">
                    Curate, test, and verify 100+ AI shopping tools across 20+
                    categories. Updated weekly with new tools and features.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-360">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-blue-100 grid place-items-center" data-id="element-361">
                  <Users size={24} className="text-blue-600" data-id="element-362" />
                </div>
                <div data-id="element-363">
                  <h3 className="font-bold text-slate-900 mb-2" data-id="element-364">
                    Who We Serve
                  </h3>
                  <p className="text-sm text-slate-700" data-id="element-365">
                    Everyday shoppers, deal hunters, fashion enthusiasts, tech
                    buyers, and anyone looking to shop smarter with AI.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-366">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-green-100 grid place-items-center" data-id="element-367">
                  <Shield size={24} className="text-green-600" data-id="element-368" />
                </div>
                <div data-id="element-369">
                  <h3 className="font-bold text-slate-900 mb-2" data-id="element-370">
                    Our Standards
                  </h3>
                  <p className="text-sm text-slate-700" data-id="element-371">
                    Every AI advisor is manually reviewed. We only list tools
                    we've personally tested and verified.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-372">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-pink-100 grid place-items-center" data-id="element-373">
                  <Heart size={24} className="text-pink-600" data-id="element-374" />
                </div>
                <div data-id="element-375">
                  <h3 className="font-bold text-slate-900 mb-2" data-id="element-376">Our Values</h3>
                  <p className="text-sm text-slate-700" data-id="element-377">
                    Independent, unbiased, transparent. We rank agents by
                    performance, not payments.
                  </p>
                </div>
              </div>
            </div>

            {/* Independent & Unbiased */}
            <div className="my-12 p-8 rounded-2xl bg-slate-900 text-white text-center" data-id="element-378">
              <h2 className="text-2xl font-bold mb-3" data-id="element-379">
                Independent. Unbiased. Transparent.
              </h2>
              <p className="text-xl font-semibold mb-2" data-id="element-380">
                We Don't Rank Agents by Payments.
              </p>
              <p className="text-xl font-semibold" data-id="element-381">
                We Rank Them by Performance.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4" data-id="element-382">
              Why ShoppingExpert.ai?
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-383">
              The AI shopping landscape is exploding with new tools every week.
              From ChatGPT's shopping features to specialized fashion stylists
              and travel planners, it's overwhelming to know which tool to use
              for what.
            </p>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-384">
              We created ShoppingExpert.ai to solve this problem. Our team tests
              every tool, verifies features, and organizes them by use case so
              you can find exactly what you need in seconds.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4" data-id="element-385">
              Our Coverage
            </h2>
            <ul className="grid sm:grid-cols-2 gap-3 mb-6" data-id="element-386">
              <li className="flex items-center gap-2 text-slate-700" data-id="element-387">
                <span className="text-green-600" data-id="element-388">✓</span> General AI Shopping
                Assistants
              </li>
              <li className="flex items-center gap-2 text-slate-700" data-id="element-389">
                <span className="text-green-600" data-id="element-390">✓</span> Fashion & Style
                Advisors
              </li>
              <li className="flex items-center gap-2 text-slate-700" data-id="element-391">
                <span className="text-green-600" data-id="element-392">✓</span> Travel & Flight
                Planners
              </li>
              <li className="flex items-center gap-2 text-slate-700" data-id="element-393">
                <span className="text-green-600" data-id="element-394">✓</span> Grocery & Meal
                Planning
              </li>
              <li className="flex items-center gap-2 text-slate-700" data-id="element-395">
                <span className="text-green-600" data-id="element-396">✓</span> Electronics & Tech
                Advisors
              </li>
              <li className="flex items-center gap-2 text-slate-700" data-id="element-397">
                <span className="text-green-600" data-id="element-398">✓</span> Deal Finders & Price
                Trackers
              </li>
              <li className="flex items-center gap-2 text-slate-700" data-id="element-399">
                <span className="text-green-600" data-id="element-400">✓</span> Human Expert Services
              </li>
              <li className="flex items-center gap-2 text-slate-700" data-id="element-401">
                <span className="text-green-600" data-id="element-402">✓</span> Voice Shopping
                Assistants
              </li>
            </ul>

            {/* Community-Powered */}
            <div className="my-12 p-6 rounded-2xl bg-gradient-to-br from-purple-50 to-pink-50 border-2 border-purple-200" data-id="element-403">
              <h2 className="text-xl font-bold text-slate-900 mb-3 text-center" data-id="element-404">
                Community-Powered Directory
              </h2>
              <p className="text-slate-700 mb-4 text-center text-sm" data-id="element-405">
                We grow the directory with real submissions from shoppers, AI
                builders, retail professionals, and creators.
              </p>
              <p className="text-slate-700 mb-3 text-center text-sm" data-id="element-406">
                Know an AI sales advisor we should add?
              </p>
              <div className="text-center" data-id="element-407">
                <a href="mailto:info@shopilots.com" className="inline-flex items-center gap-2 px-5 py-2.5 bg-slate-900 text-white rounded-xl font-semibold hover:bg-black transition-colors text-sm" data-id="element-408">
                  Send it to: info@shopilots.com
                </a>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4" data-id="element-409">
              Get in Touch
            </h2>
            <p className="text-slate-700 leading-relaxed mb-6" data-id="element-410">
              Have a tool suggestion? Found an error? Want to partner with us?
              We'd love to hear from you.
            </p>
            <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 bg-slate-900 text-white rounded-xl font-semibold hover:bg-black transition-colors" data-id="element-411">
              Contact Us
            </Link>
          </div>
        </div>
      </main>

      {/* Footer with Review Method */}
      <footer className="border-t border-slate-200 bg-white mt-16" data-id="element-412">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-8" data-id="element-413">
          {/* Our Review Method */}
          <div className="mb-8 p-6 rounded-2xl bg-gradient-to-br from-blue-50 to-cyan-50 border-2 border-blue-200" data-id="element-414">
            <h3 className="text-xl font-bold text-slate-900 mb-3 text-center" data-id="element-415">
              Our Review Method
            </h3>
            <p className="text-sm text-slate-700 mb-4 text-center" data-id="element-416">
              How We Evaluate AI Agents
            </p>
            <p className="text-sm text-slate-700 mb-4 text-center" data-id="element-417">
              Every agent on ShoppingExpert.ai passes a strict, Trustpilot-style
              review:
            </p>
            <div className="flex flex-wrap justify-center gap-2 mb-4" data-id="element-418">
              {['Accuracy of recommendations', 'Transparency & reliability', 'Real product knowledge', 'Consistency across categories', 'User satisfaction signals'].map((item, idx) => <span key={idx} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-white border border-blue-200 text-slate-700 text-xs font-medium" data-id="element-419">
                  <span className="text-green-600 font-bold" data-id="element-420">✓</span>
                  {item}
                </span>)}
            </div>
            <p className="text-sm text-slate-900 font-bold text-center" data-id="element-421">
              If it doesn't meet our standard — it doesn't get listed.
            </p>
          </div>

          <div className="text-center mb-4" data-id="element-422">
            <p className="text-sm font-semibold text-slate-900 mb-1" data-id="element-423">
              ShoppingExpert.ai
            </p>
            <p className="text-xs text-slate-600" data-id="element-424">
              The independent directory of AI Shopping Agents & Sales Advisors.
            </p>
            <p className="text-xs text-slate-600" data-id="element-425">
              Updated weekly. Curated by ShoPilots.
            </p>
          </div>
          <p className="text-sm text-slate-500 text-center" data-id="element-426">
            © 2025 ShoppingExpert.ai. All rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}